module.exports = __webpack_public_path__ + "static/software-76fed0185ef909a912903c3529e5df5c.webp";